<template>
  <div class="form-container">
    <div class="row-item">
      <span class="label">Upload Employee Photo</span>
      <upload-image @change="(val)=>personal.photo_url=val.data.Location"></upload-image>
    </div>
    <div class="row">
      <div class="col-3">
        <txt class="name" label="Code*" type="text" v-model="personal.code"></txt>
      </div>
      <div class="radio-container col-6">
        <div>Gender</div>
        <div class="radio-btn">
          <tl-radio name="gender" label="Male" id="gender1" value="male" v-model="personal.gender" />
          <tl-radio
            name="gender"
            label="Female"
            id="gender2"
            value="female"
            v-model="personal.gender"
          />
          <tl-radio
            name="gender"
            label="Other"
            id="gender3"
            value="other"
            v-model="personal.gender"
          />
          <tl-radio
            name="gender"
            label="Prefer not to tell"
            id="gender4"
            value="na"
            v-model="personal.gender"
          />
        </div>
      </div>
    </div>
    <div class="threeColumnGrid">
      <txt label="Employee Name*" v-validate="'required|alpha'" type="text" v-model="personal.name"></txt>
      <div>
        <span class="label">Date of Birth*</span>
        <date-picker
          @datevalue="(val)=>personal.dob=val"
          v-validate="'required'"
          :value="personal.dob"
        />
      </div>
      <txt
        label="Personal Mobile Number"
        type="number"
        v-maxchars="10"
        v-model="personal.phone_number"
      ></txt>
      <txt label="Phone no." type="number" v-maxchars="10" v-model="personal.mobile_number"></txt>
      <txt
        label="Personal Email"
        v-validate="{required: true, regex: emailRegex, max:100}"
        type="email"
        v-model="personal.email_id"
      ></txt>
      <txt
        label="Emergency contact name"
        v-validate="'alpha'"
        type="text"
        v-model="personal.emergency_contact_name"
      ></txt>
      <txt
        label="Emergency contact no."
        type="number"
        v-maxchars="10"
        v-model="personal.emergency_contact_number"
      ></txt>
      <txt
        label="Permanent Retirement Account Number"
        type="number"
        v-maxchars="12"
        v-model="personal.pran_number"
      ></txt>
      <txt label="PAN No." type="text" v-model="personal.pan_number"></txt>
      <txt label="Aadhar No." type="number" v-maxchars="12" v-model="personal.adhar_number"></txt>
    </div>
    <div class="radio-container col-6">
      <div>Tax Status</div>
      <div class="radio-btn">
        <tl-radio
          name="tax"
          label="Resident"
          id="tax1"
          value="resident"
          v-model="personal.employee_tax_status"
        />
        <tl-radio
          name="tax"
          label="NRI"
          id="tax2"
          value="nri"
          v-model="personal.employee_tax_status"
        />
        <tl-radio
          name="tax"
          label="XPAT"
          id="tax3"
          value="xpat"
          v-model="personal.employee_tax_status"
        />
      </div>
    </div>
    <div class="header header2">
      <span class="text">Permanent Address</span>
    </div>
    <div class="row">
      <div class="col-6">
        <txt
          label="Address Line 1"
          name="addresLineOne"
          data-vv-as="Address"
          type="text"
          v-model="personal.permanent_address.addresLineOne"
          v-validate="{required: true, regex:/^[a-z\sA-Z\s0-9]*\s*[a-z\sA-Z\s0-9]*$/}"
          :classname="errors.has('addresLineOne')"
          :errormsg="errors.first('addresLineOne')"
        ></txt>
      </div>
      <div class="col-6">
        <txt
          label="Address Line 2"
          name="addressLineTwo"
          type="text"
          data-vv-as="Address"
          v-model="personal.permanent_address.addressLineTwo"
          v-validate="{required: true, regex:/^[a-z\sA-Z\s0-9]*\s*[a-z\sA-Z\s0-9]*$/}"
          :classname="errors.has('addressLineTwo')"
          :errormsg="errors.first('addressLineTwo')"
        ></txt>
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="Country"
          name="country"
          labelText="name"
          :options="country"
          :selected="setCountryID(personal.permanent_address.countryID)"
          :value="setCountryID(personal.permanent_address.countryID)"
          @change="(val)=>personal.permanent_address.countryID=getID(val)"
          v-validate="'required'"
          :classname="errors.has('country')"
          :errormsg="errors.first('country')"
        ></tl-select>
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="State"
          name="state"
          labelText="name"
          :options="state"
          :selected="setStateID(personal.permanent_address.stateID)"
          :value="setStateID(personal.permanent_address.stateID)"
          @change="(val)=>personal.permanent_address.stateID=getID(val)"
          v-validate="'required'"
          :classname="errors.has('state')"
          :errormsg="errors.first('state')"
        ></tl-select>
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="City"
          name="city"
          labelText="name"
          v-validate="'required'"
          :options="city"
          :selected="setCityID(personal.permanent_address.cityID)"
          :value="setCityID(personal.permanent_address.cityID)"
          @change="(val)=>personal.permanent_address.cityID=getID(val)"
          :classname="errors.has('city')"
          :errormsg="errors.first('city')"
        ></tl-select>
      </div>
      <div class="col-6 margintop-20">
        <txt
          label="Pincode"
          type="text"
          name="pincode"
          v-model="personal.permanent_address.pinCode"
          v-validate="{required: true, regex:/^[1-9]{1}[0-9]{5}$/}"
          :classname="errors.has('pincode')"
          :errormsg="errors.first('pincode')"
        ></txt>
      </div>
    </div>
    <div class="header header2">
      <span class="text">Communication Address</span>
    </div>
    <div class="row">
      <div class="col-12">
        <tl-checkbox
          class="headcheck"
          label="Same as Registered Address"
          v-model="headsameAsReg"
          @change="(val)=>mapAddress(val)"
        />
      </div>
      <div class="col-6 margintop-10">
        <txt
          label="Address Line 1"
          type="text"
          name="headOfficeAddressLineOne"
          data-vv-as="address"
          v-model="personal.communication_address.addresLineOne"
          v-validate="{required: true, regex:/^[a-z\sA-Z\s0-9]*\s*[a-z\sA-Z\s0-9]*$/}"
          :classname="errors.has('headOfficeAddressLineOne')"
          :errormsg="errors.first('headOfficeAddressLineOne')"
        ></txt>
      </div>
      <div class="col-6 margintop-10">
        <txt
          label="Address Line 2"
          type="text"
          name="headOfficeAddressLineTwo"
          data-vv-as="address"
          v-model="personal.communication_address.addressLineTwo"
          v-validate="{required: true, regex:/^[a-z\sA-Z\s0-9]*\s*[a-z\sA-Z\s0-9]*$/}"
          :classname="errors.has('headOfficeAddressLineTwo')"
          :errormsg="errors.first('headOfficeAddressLineTwo')"
        ></txt>
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="Country"
          labelText="name"
          name="headOfficeCountry"
          data-vv-as="country"
          :options="country"
          :selected="setCountryID(personal.communication_address.countryID)"
          :value="setCountryID(personal.communication_address.countryID)"
          @change="(val)=>personal.communication_address.countryID=getID(val)"
          v-validate="'required'"
          :classname="errors.has('headOfficeCountry')"
          :errormsg="errors.first('headOfficeCountry')"
        ></tl-select>
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="State"
          labelText="name"
          name="headOfficeState"
          data-vv-as="state"
          :options="state"
          :selected="setStateID(personal.communication_address.stateID)"
          :value="setStateID(personal.communication_address.stateID)"
          @change="(val)=>personal.communication_address.stateID=getID(val)"
          v-validate="'required'"
          :classname="errors.has('headOfficeState')"
          :errormsg="errors.first('headOfficeState')"
        />
      </div>
      <div class="col-6 margintop-20">
        <tl-select
          class="customwidth"
          label="City"
          labelText="name"
          name="headOfficeCity"
          data-vv-as="city"
          :options="city"
          :selected="setCityID(personal.communication_address.cityID)"
          :value="setCityID(personal.communication_address.cityID)"
          @change="(val)=>personal.communication_address.cityID=getID(val)"
          v-validate="'required'"
          :classname="errors.has('headOfficeCity')"
          :errormsg="errors.first('headOfficeCity')"
        ></tl-select>
      </div>
      <div class="col-6 margintop-20">
        <txt
          label="Pincode"
          type="text"
          name="pinCode"
          data-vv-as="pincode"
          v-model="personal.communication_address.pinCode"
          v-validate="{required: true, regex:/^[1-9]{1}[0-9]{5}$/}"
          :classname="errors.has('pinCode')"
          :errormsg="errors.first('pinCode')"
        ></txt>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "@/components/Upload.vue";
import { selectMixin } from "@/mixins/selectMixin";
import { mapState, mapActions } from "vuex";
import * as globalRegexVar from "@/apis/config.js";
export default {
  mixins: [selectMixin],
  components: {
    Upload
  },
  props: {
    personalInfo: Object
  },
  computed: {
    ...mapState({
      personalObj: state => state.onboard.employees.record[0]
    })
  },
  data() {
    return {
      emailRegex: null,
      personal: {
        photo_url: "",
        permanent_address: {},
        communication_address: {},
        gender: "male",
        employee_tax_status: "resident"
      },
      headsameAsReg: false,
      city: [
        { id: "91190d69-ab53-4d35-8a92-1c34ccfcd6c2", name: "Bangalore" },
        { id: "91190d69-ab53-4d35-8a92-1c34ccfcd6c2", name: "Hyderabad" }
      ],
      state: [
        { id: "589d6571-3edf-4483-b7cc-5ef4fe3fbece", name: "Karnataka" },
        { id: "589d6571-3edf-4483-b7cc-5ef4fe3fbece", name: "Telangana" }
      ],
      country: [
        { id: "589d6571-3edf-4483-b7cc-5ef4fe3fbece", name: "India" },
        { id: "589d6571-3edf-4483-b7cc-5ef4fe3fbece", name: "USA" }
      ]
    };
  },
  mounted() {
    // this.getPersonnelData();

    this.emailRegex = globalRegexVar.Regex.EMAIL;
  },
  watch: {
    personal: function(val) {
      this.$emit("personal", val);
    },
    deep: true
  },
  methods: {
    ...mapActions({
    }),
    setCityID(value) {
      if (value) {
        return this.setSelectedOptionsByID(this.city, value);
      }
    },
    changeState(event) {
      this.formData.stateId = event.id;
    },
    changeCity(event) {
      this.formData.cityId = event.id;
    },
    setStateID(value) {
      if (value) {
        return this.setSelectedOptionsByID(this.state, value);
      }
    },
    setCountryID(value) {
      if (value) {
        return this.setSelectedOptionsByID(this.country, value);
      }
    },
    getPersonnelData() {
      this.personal['code'] = this.personalObj.code
      this.personal['name'] = this.personalObj.name
      this.personal['phone_number'] = this.personalObj.phone_number
      this.personal['mobile_number'] = this.personalObj.mobile_number
      this.personal['email_id'] = this.personalObj.email_id
      this.personal['emergency_contact_name'] = this.personalObj.emergency_contact_name
      this.personal['emergency_contact_number'] = this.personalObj.emergency_contact_number
      this.personal['employee_tax_status'] = this.personalObj.employee_tax_status
      this.personal['permanent_address'] = this.personalObj.permanent_address
      this.personal['pan_number'] = this.personalObj.pan_number
      this.personal['adhar_number'] = this.personalObj.adhar_number
    },
    mapAddress(val) {
      if (val) {
        this.personal.communication_address.addresLineOne = this.personal.permanent_address.addresLineOne;
        this.personal.communication_address.addressLineTwo = this.personal.permanent_address.addressLineTwo;
        this.personal.communication_address.cityID = this.personal.permanent_address.cityID;
        this.personal.communication_address.stateID = this.personal.permanent_address.stateID;
        this.personal.communication_address.countryID = this.personal.permanent_address.countryID;
        this.personal.communication_address.pinCode = this.personal.permanent_address.pinCode;
      } else {
        this.personal.headOfficeAddress = this.$_.cloneDeep({});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.upload-container {
  width: 30%;
  margin-bottom: 30px;
}

.radio-container {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 20px 0px;
  color: #404040;
  font-size: $font-size-small;
  *:nth-child(n) {
    margin-bottom: 10px;
  }
}
.radio-btn {
  display: flex;
  *:nth-child(n) {
    // margin-right: 10px;
  }
}
.label {
  font-size: $font-size-small;
  font-weight: 300;
  margin-bottom: 5px;
  color: #6e6e6e;
}
.two-column-container {
  display: flex;
  *:nth-child(n) {
    margin-right: 35px;
  }
}
.employee-code-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .label {
    font-size: $font-size-small;
    color: $color-primary;
    text-decoration: underline;
  }
}
</style>
